import {cn} from '@bem-react/classname';

export const cnContainsSecretMessage = cn('ContainsSecretMessage');
